import { Center, rem, Text } from '@mantine/core';
import { CAP_TABLE_VALUES_HELD_TYPE } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/tableSettings.ts';
import { useTranslationCapChart } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface Props {
	valuesHeldType: CAP_TABLE_VALUES_HELD_TYPE;
}

export const CapChartValueIndicator = ({ valuesHeldType }: Props) => {
	const tCapChart = useTranslationCapChart();
	const isVotes = valuesHeldType === CAP_TABLE_VALUES_HELD_TYPE.VOTES;

	return (
		<Center
			w={16}
			h={16}
			bg={isVotes ? 'blue.0' : 'gray.2'}
			style={{ borderRadius: rem(3), flexShrink: 0 }}
		>
			<Text fz="sm" fw={600} lh={rem(16)} c={isVotes ? 'blue.8' : 'dark.8'}>
				{isVotes
					? tCapChart('values.votes_indicator')
					: tCapChart('values.units_indicator')}
			</Text>
		</Center>
	);
};
